<template>
  <a
    :href="oneClickInquiryEnabled ? `javascript:void(0);` : `#inquiry-form`"
    @click.prevent="handleClick"
  >
    求人票にない情報についてもお問い合わせください！<br />
    <span class="m3-button m3-button--secondary"
      >お問い合わせして詳細を聞く<i
        v-if="!oneClickInquiryEnabled"
        class="atlas-glyphs-m-arrow-down"
    /></span>
  </a>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import pcrContents from '@component_path/pages/pc/positions/show/module/pcr_contents';

const store = useStore();

const props = defineProps({
  oneClickInquiryEnabled: {
    type: Boolean,
    default: false
  }
});

const pcrContent = computed(() =>
  props.oneClickInquiryEnabled ? pcrContents.blur_oneclick : pcrContents.blur
);

const setModalName = name =>
  store.dispatch('oneClickInquiry/setModalName', name);
const setPcrParams = params =>
  store.dispatch('requestParam/setPcrParams', params);

const handleClick = () => {
  setPcrParams({ key: 'pcr_content', value: pcrContent.value });
  if (props.oneClickInquiryEnabled) {
    setModalName('oneClickInquiry');
  }
};
</script>
